import React, { useState } from "react";
import "./id-card-config.scss";


const ConductCertificate = () => {


    const ConductStudents = [

        {
            name: "U. Sathvika",
            guardian: "U. Raviteja",
            admission: "252628",
            className: "PP-1",
            section: "A",
            course: "PRE PRIMARY",
            fromYear: "2025",
            toYear: "2026",
            curriculum: "SSC",
            academic_year: "2026-27"
        },


        {
            name: "Rahul Kumar",
            guardian: "Ramesh Kumar",
            admission: "252629",
            className: "1st",
            section: "B",
            course: "PRIMARY",
            fromYear: "2025",
            toYear: "2026",
            curriculum: "CBSE",
            academic_year: "2026-27"
        }

    ];





    const [searchConduct, setSearchConduct] = useState("");

    const [showListConduct, setShowListConduct] = useState(false);




    const [formData, setFormData] = useState({

        certificateType: "Conduct Certificate",

        academic_year: "",

        curriculum: "",

        className: "",

        section: "",

        student: "",

        guardian: "",

        admissionNo: "",

        course: "",

        fromYear: "",

        toYear: "",

        conduct: "Excellent",

        issueDate: "18 Jun 2026",

        place: "Vijayawada"

    });





    const handleChange = (e) => {


        const { name, value } = e.target;


        setFormData(prev => ({

            ...prev,

            [name]: value


        }));



    }





    const selectStudent = (stu) => {


        setSearchConduct(stu.name);


        setFormData({

            certificateType: "Conduct Certificate",

            student: stu.name,

            guardian: stu.guardian,

            admissionNo: stu.admission,

            className: stu.className,

            section: stu.section,

            course: stu.course,

            fromYear: stu.fromYear,

            toYear: stu.toYear,

            curriculum: stu.curriculum,

            academic_year: stu.academic_year,

            conduct: "",

            issueDate: "",

            place: ""

        });


        setShowListConduct(false);


    }






    const filteredStudents = ConductStudents.filter(item =>

        item.name
            .toLowerCase()
            .includes(searchConduct.toLowerCase())

    );





    const displayValue = (value) => {

        return value && value.trim() !== ""
            ?
            value
            :
            "________";

    }





    return (

        <div className=" mt-3">



            {/* FILTER */}


            <div className="card no-print">


                <div className="card-header">

                    Generate Conduct Certificate

                </div>


                <div className="card-body">


                    <div className="row g-3">



                        <div className="col-md-3">

                            <label>
                                Academic Year
                            </label>

                            <select

                                className="form-select"

                                name="academic_year"

                                value={formData.academic_year}

                                onChange={handleChange}

                            >

                                <option value="">
                                    Select
                                </option>

                                <option>
                                    2026-27
                                </option>

                                <option>
                                    2025-26
                                </option>


                            </select>

                        </div>




                        <div className="col-md-3">

                            <label>
                                Curriculum
                            </label>

                            <select

                                className="form-select"

                                name="curriculum"

                                value={formData.curriculum}

                                onChange={handleChange}

                            >

                                <option value="">
                                    Select
                                </option>

                                <option>
                                    SSC
                                </option>

                                <option>
                                    CBSE
                                </option>

                            </select>


                        </div>





                        <div className="col-md-3">

                            <label>
                                Class
                            </label>

                            <select

                                className="form-select"

                                name="className"

                                value={formData.className}

                                onChange={handleChange}

                            >


                                <option value="">
                                    Select
                                </option>

                                <option>
                                    PP-1
                                </option>

                                <option>
                                    PP-2
                                </option>

                                <option>
                                    1st
                                </option>

                                <option>
                                    2nd
                                </option>


                            </select>


                        </div>





                        <div className="col-md-3">

                            <label>
                                Section
                            </label>


                            <select

                                className="form-select"

                                name="section"

                                value={formData.section}

                                onChange={handleChange}

                            >

                                <option value="">
                                    Select
                                </option>

                                <option>
                                    A
                                </option>

                                <option>
                                    B
                                </option>

                            </select>


                        </div>





                        <div className="col-md-3 position-relative">


                            <label>
                                Student
                            </label>


                            <input

                                className="form-control"

                                value={searchConduct}

                                onChange={(e) => {

                                    setSearchConduct(e.target.value);

                                    setShowListConduct(true);

                                }}

                                onFocus={() => setShowListConduct(true)}


                            />



                            {

                                showListConduct && searchConduct &&

                                <div className="student-list">


                                    {

                                        filteredStudents.map((stu, index) => (

                                            <div

                                                key={index}

                                                onClick={() => selectStudent(stu)}

                                            >

                                                <b>
                                                    {stu.name}
                                                </b>

                                                <br />

                                                Guardian :
                                                {stu.guardian}


                                            </div>


                                        ))

                                    }


                                </div>


                            }



                        </div>






                        <div className="col-md-3">


                            <label>
                                Conduct
                            </label>


                            <select

                                className="form-select"

                                name="conduct"

                                value={formData.conduct}

                                onChange={handleChange}

                            >


                                <option>
                                    Excellent
                                </option>

                                <option>
                                    Good
                                </option>

                                <option>
                                    Satisfactory
                                </option>


                            </select>


                        </div>





                        <div className="col-md-3">

                            <label>
                                Place
                            </label>

                            <input

                                className="form-control"

                                name="place"

                                value={formData.place}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-3">

                            <label>
                                Issue Date
                            </label>

                            <input

                                type="date"

                                className="form-control"

                                name="issueDate"

                                value={formData.issueDate}

                                onChange={handleChange}

                            />

                        </div>



                    </div>


                </div>


            </div>







            {/* CERTIFICATE */}



            <div className="print-area">
                <div className="certificate">
                    <div className="certificate-border">
                        <div className="school-header">
                            <img

                                src="https://www.srinitheplayschool.com/img/logo.png"

                                className="school-logo"

                            />
                            <div>
                                <h2>
                                    SRINI THE PLAY SCHOOL & ACADEMY
                                </h2>
                                <p>
                                    Vijayawada, Andhra Pradesh
                                    <br />
                                    Contact : 7893077007
                                </p>
                            </div>
                        </div>

                        <h1>
                            CONDUCT CERTIFICATE
                        </h1>

                        <div className="conduct-body">

                            <span>

                                This is to certify that Mr./Ms.

                                <b>
                                    &nbsp;{displayValue(formData.student)}
                                </b> &nbsp;

                                son/daughter of

                                <b>
                                    &nbsp;{displayValue(formData.guardian)}
                                </b>

                                &nbsp; bearing Admission No.

                                <b>
                                    &nbsp;{displayValue(formData.admissionNo)}
                                </b> &nbsp;

                                was a student of our school in

                                <b>
                                    &nbsp;{displayValue(formData.course)}
                                </b>

                            </span>



                            &nbsp;<span>

                                Class :

                                <b>
                                    &nbsp;
                                    {displayValue(formData.className)}
                                    -
                                    {displayValue(formData.section)}
                                </b>

                            </span>




                            &nbsp;<span>

                                During the period of study from

                                <b>
                                    &nbsp;{displayValue(formData.fromYear)}
                                </b>

                                to

                                <b>
                                    &nbsp;{displayValue(formData.toYear)}
                                </b> &nbsp;

                                his/her character and conduct were

                                <b>
                                    &nbsp;{displayValue(formData.conduct)}
                                </b>

                            </span>




                            &nbsp;<span>

                                Academic Year :

                                <b>
                                    &nbsp;{displayValue(formData.academic_year)}
                                </b>

                            </span> &nbsp;



                            <span>

                                Curriculum :

                                <b>
                                    &nbsp;{displayValue(formData.curriculum)}
                                </b>

                            </span>



                        </div>





                        <div className="certificate-footer">


                            <div>

                                Date :
                                {formData.issueDate}

                                <br />

                                Place :
                                {formData.place}

                            </div>



                            <div>

                                _________________

                                <br />

                                PRINCIPAL

                            </div>


                        </div>





                    </div>


                </div>


            </div>





            <div className="no-print text-center">


                <button

                    className="btn btn-success mt-3"

                    onClick={() => window.print()}

                >

                    Print Certificate

                </button>


            </div>





        </div>

    )

}


export default ConductCertificate;